export * from './FAQSearch'
export { default } from './FAQSearch'
